<style scoped xmlns="http://www.w3.org/1999/html">

    @import "index.css";
    import appcontent from "@/viws/shuping/appcontent"
    .imgCover {
        opacity: .3
    }

</style>

<template>
    <div id="app">
        <div class="ww_middle">
            <div class="ww_head">
                <img src='' alt='' id="pic"  style="position: absolute;z-index:-1;top: 0;left: 0;width: 100%;height: 100%">

                <div  @contextmenu.prevent="showMenu"  style="position: absolute;z-index:2500;top: 0;left: 0;width: 100%;height: 100%;" ></div>
                <div class="title">生态屏控制中心</div>
                <div style="position: absolute;z-index:2501;left: 1%;top: 5px;width: 30%">
                    <span class="middle-title" style="position: absolute;left: 1%;">项目名称：{{userInfo.nickName}}</span>
                    <span class="middle-title" style="position: absolute;left: 1%;top: 20px;" @click="selectArea()">区域名称：{{areaName}}
                        <Icon type="ios-arrow-down" size="15" color="#FFFFFF"/>
                    </span>
                </div>
                <div style="position: absolute;z-index:2501;left: 80%;top: 5px;">
                    <Upload class=""
                            action=""
                            :show-file-list="false"
                            :before-upload="beforeAvatarUpload">
                        <Button icon="ios-cloud-upload-outline">新增</Button>
                    </Upload>
                </div>
                <div style="position: absolute;z-index:2501;left: 90%;top: 5px;">
                    <Upload class=""
                            action=""
                            :show-file-list="false"
                            :before-upload="editAvatarUpload">
                        <Button icon="ios-cloud-upload-outline">修改</Button>
                    </Upload>
                </div>
                <div style="position: absolute;z-index:2501;left: 80%;top: 45px;">
                    <span>图片大小1080*785px</span>
                </div>
            </div>
            <!--中间设备坐标显示-->
            <div v-for="(item,index) in menuList" :key="index" >
                <!--<div v-if="isSensor(item)" v-show="item.axisX>0" :style="{left:item.axisX+'px',top:item.axisY+'px'}" class="map">-->
                <!--<img  src="../daping/assets/img/switch_ico.png" alt="">-->
                <!--<li>-->
                <!--<div style="position: absolute;top: 0.04rem;left:-0.06rem;width: 0.15rem;height: 0.15rem;border-radius: 50%;background-color: #28EDF8;"></div>-->
                <!--<span style="position: absolute;border: 2px solid #28EDF8;border-radius:0.1rem;top: 0.1rem;left:0;padding: 0.1rem 0.1rem 0.1rem 0.1rem">30</span>-->
                <!--<span style="position: absolute;border-top: 2px solid #66AEDE;width: 120px;text-align:right;top: 0.6rem;left: 0">{{item.deviceName}}</span>-->
                <!--<span style="position: absolute;top: 0.4rem;left:0;width: 120px;text-align:right;">温度<span style="color: #31D16F;margin-left: 0.1rem">适宜</span></span>-->
                <!--<span style="position: absolute;top: 0.85rem;left:0;width:120px;text-align:right;">-->
                <!--<span style="margin-left: 0.1rem">湿度</span><span style="color: #D082B4;margin-left: 0.1rem">45</span>-->
                <!--<span style="margin-left: 0.1rem">温度</span><span style="color: #FFCB31;margin-left: 0.1rem">12.2</span>-->
                <!--</span>-->
                <!--</li>-->
                <!--</div>-->
                <!--<div v-else v-show="item.axisX>0" :style="{left:item.axisX+'px',top:item.axisY+'px'}" class="map">-->
                <!--<img  src="../daping/assets/img/switch_ico.png" alt="">-->
                <!--<li>-->
                <!--<div style="position: absolute;top: 0.04rem;left:-0.06rem;width: 0.15rem;height: 0.15rem;border-radius: 50%;background-color: #28EDF8;"></div>-->
                <!--<span style="position: absolute;border: 2px solid #28EDF8;border-radius:0.1rem;top: 0.1rem;left:0;padding: 0.1rem 0.1rem 0.1rem 0.1rem;color: #999999">&#45;&#45;</span><br/>-->
                <!--<span style="position: absolute;border-top: 2px solid #66AEDE;width: 120px;text-align:right;top: 0.6rem">{{item.deviceName}}</span>-->
                <!--</li>-->
                <!--</div>-->
                <div v-if="isSensor(item)" v-show="item.axisX>0" :style="{left:item.axisX+'px',top:item.axisY+'px'}" class="map">
                    <img v-if="item.img" :src="imgSrc+item.img">
                    <li>
                        <div style="position: absolute;top: 0.04rem;left:-0.06rem;width: 0.15rem;height: 0.15rem;border-radius: 50%;background-color: #28EDF8;"></div>
                        <span v-if="item.info" style="position: absolute;border: 2px solid #28EDF8;border-radius:0.1rem;top: 0.1rem;left:0;padding: 0.1rem 0.1rem 0.1rem 0.1rem">{{item.info.infoList[0].value}}</span>
                        <span v-else style="position: absolute;border: 2px solid #28EDF8;border-radius:0.1rem;top: 0.1rem;left:0;padding: 0.1rem 0.1rem 0.1rem 0.1rem;color: #999999">--</span>
                        <span style="position: absolute;border-top: 2px solid #66AEDE;width: 140px;text-align:right;top: 40px;left: 0">{{item.deviceName}}</span>
                        <span v-if="item.info" style="position: absolute;top: 20px;left:0;width: 140px;text-align:right;">{{item.info.infoList[0].name}}<span style="margin-left: 0.1rem" :style="{color:item.info.infoList[0].level==1? '#FFCB31': item.info.infoList[0].level==2? '#31D16F': '#D082B4'}">{{item.info.infoList[0].title}}</span></span>
                        <span v-if="item.info">
                        <span v-if="item.info.infoList.length>1" style="position: absolute;top: 60px;left:0;width:140px;text-align:right;" >
                            <span v-for="(item1, index1) in  item.info.infoList.slice(1, item.info.infoList.length)" :key="index1">
                                <span  style="margin-left: 0.1rem">{{item1.name}}</span><span style="margin-left: 0.1rem" :style="{color:item1.level==1? '#FFCB31': item1.level==2? '#31D16F': '#D082B4'}">{{item1.value}}</span>
                            </span>
                        </span>
                    </span>

                    </li>
                </div>
                <div v-else v-show="item.axisX>0" :style="{left:item.axisX+'px',top:item.axisY+'px'}" class="map">
                    <img v-if="item.img" :src="imgSrc+item.img">
                    <li>
                        <div style="position: absolute;top: 0.04rem;left:-0.06rem;width: 0.15rem;height: 0.15rem;border-radius: 50%;background-color: #28EDF8;"></div>
                        <span style="position: absolute;border: 2px solid #28EDF8;border-radius:0.1rem;top: 0.1rem;left:0;padding: 0.1rem 0.1rem 0.1rem 0.1rem;">
                        <span v-if="!item.status" style="color: #999999;">--</span>
                        <span v-else-if="item.switchStatus"  style="color: #31D16F;">开启</span>
                        <span v-else class="sm-title" style="color: #999999;">关闭</span>
                    </span><br/>
                        <span style="position: absolute;border-top: 2px solid #66AEDE;width: 100px;text-align:right;top: 40px">{{item.deviceName}}</span>
                    </li>
                </div>
            </div>


            <appcontent></appcontent>
        </div>
        <!--地图选择-->
        <div class="rightList">
            <span style="font-size: 18px;">地图列表:</span>
            <div v-if="mapList.length>0"  style="height: 100%;overflow: hidden;" >
                <div v-for="(item,index) in mapList" :key="index">
                    <li  tapmode="active-style"  style="height: 20px;width: 100%;border-bottom:1px solid black;">
                        <span class="left-title" :id="item.mapId" @click="qhMap(item)">{{item.mapName}}</span>
                        <input v-show="!sorting" type="number" v-model="item.sort" style="float: left;width: 20%">
                        <Icon type="ios-close-circle" @click="closeMap(item.mapId)"  style="float:right;padding-right: 3px;" size=20></Icon>
                    </li>
                </div>
                <div  class="demo-drawer-footer">
                    <Button v-show="sorting" @click="sortIng">修改排序</Button>
                    <Button v-show="!sorting" type="primary" @click="sortMap">提交排序</Button>
                </div>
            </div>
            <!--没有目录-->
            <p v-else style="text-align: center; padding: 20px 0; color:#000000">暂无地图</p>
        </div>

        <!--右键菜单-->
        <div v-show="visible" :style="{left:axisX+'px',top:axisY+'px'}" style="overflow-y: auto;height: 400px;width: 200px" class="contextmenu">
            <div v-if="menuList.length>0">
                <ul v-for="(item,index) in menuList" :key="index">
                    <li class="menu_item" @click="savedata(item)" style="float: left;height: 30px">{{item.deviceName}}</li>
                    <img v-if="item.axisX" src="@/assets/img/error.png" @click="deleteDevice(item,index)" style="width: 30px;height: 30px;padding:5px;float: right">
                </ul>
            </div>
            <div v-else>
                <ul>
                    <li class="menu_item">该区域暂无设备</li>
                </ul>
            </div>
        </div>
        <!--右侧弹出窗口-->
        <Drawer @on-close="onClose" :title="winTitle" :width="400" v-model="show">
            <dscjShow v-if="type === 2" :sbinfo="sbInfo" @close="onClose"></dscjShow>
            <areaPop v-if="type === 1" @close="onClose" @dapingRefresh="dapingRefresh"></areaPop>
            <dscjMusic v-if="type === 3" :sbinfo="musicDevice" @close="onClose" @updateSong="updateSong"></dscjMusic>
        </Drawer>
    </div>

</template>

<script>
    import { fullScreen } from "../layout/components/headerBar_components";
    import nopic from '@/assets/img/no_pic.png';
    import bgPic from '../daping/assets/img/bgs.png';
    import * as echarts from 'echarts';
    import videojs from 'video.js';
    import echartUtil from '../../assets/js/DapingEchartUntil';
    import 'video.js/dist/video-js.css';
    import dscjMusic from "../znsb/music";
    import dscjShow from "../znsb/show";
    import areaPop from "../daping/area";
    import appcontent from "../shuping/appcontent";
    export default {
        name: "shuping",
        components: {
            dscjMusic, areaPop, dscjShow,fullScreen,appcontent
        },
        data() {
            // 统计图对象
            return {
                userInfo: this.$func.data.get("userInfo"),
                isFullScreen:false,
                songIndex: 0,
                mapList:[],
                dataList:[],
                modePopShow: false,
                sceneWinTitle: "",
                itemVal: {},
                sceneType: 0,
                type: 0,// 右侧弹出类型
                winTitle: "",
                progress: 0, //音乐滑条进度
                musicDevice: {},
                sbInfo: {},
                musicInfo: {progress: 0, filePath: "未播放歌曲", time: "0",cha:2,volume:20,statu:0},
                show: false,// 侧边栏
                getday:'',
                weekday: ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'],
                listStandard:[],
                trSensorList:[],//土壤传感器
                kqSensorList:[],//空气类传感器
                szSensorList:[],//水质类传感器
                rightSensorList:[{deviceName:'传感器',info:{value:'--'},deviceId:0},{deviceName:'传感器',info:{value:'--'},deviceId:0},{deviceName:'传感器',info:{value:'--'},deviceId:0},{deviceName:'传感器',info:{value:'--'},deviceId:0}],//右侧传感器数组
                sensorRecordList:[],//传感器历史记录数组
                trsdSensorList:[],
                trflSensorList:[],
                llSensor:{},
                ylSensor:{},
                trwdSensor:{},
                kqsdSensor:{},
                pmSensor:{},
                ddlSensor:{},
                llSensorList:[],
                zhpgDeviceList:[],//智慧喷灌中设备数组
                trglDeviceList:[],//土壤管理中设备数组
                hjglDeviceList:[],//环境管理中设备数组
                fwglDeviceList:[],//氛围管理中设备数组
                columnID:'zhpg',//当前栏目id
                getweek:'',
                gettime:'',
                sensorList: [],
                areaId: 0,
                areaName: '切换区域',
                //图片
                nopic: nopic,
                bgPic: bgPic,
                imgSrc: this.$func.imgSrc,
                sceneCatList: [],
                list: [],
                qitaDeviceList: [],//  开关类 （eid 含 znmb  relay valve）

                // 统计图对象数组
                centerChartTR: [],
                centerChartHJ: [],
                centerChartLSJL:[],
                audioPlayer4: null,

                //  (菜单数据)
                menuList:[],//当前栏目设备数组
                visible: false,
                axisX:0,
                axisY:0,
                mapId:1,
                mapUrl:'',
                mapName:'',
                areaNum:0,
                deviceAxisList:[],
                sort:0,
                sorting:true,
            }
        },
        computed: {},
        beforeCreate() {
            //设置背景色
            document.querySelector("body").setAttribute("style", "background:#fbfbfb");
        },
        beforeDestroy() {
            //去除背景色
            document.querySelector("body").setAttribute("style", "");
        },
        beforeMount() {

        },
        created(){
            var that = this;
            that.columnID='zhpg';
            that.listArea();
            that.getListStandard();
        },

        mounted() {
        },
        watch: {
            visible(value) {
                if (value) {
                    document.body.addEventListener('click', this.closeMenu)
                } else {
                    document.body.removeEventListener('click', this.closeMenu)
                }
            }
        },
        methods: {
            //上传地图之前
            beforeAvatarUpload(file) {
                console.log(file)
                if(file.type.indexOf('image')!=-1){
                    let reader = new FileReader();
                    var that=this
                    reader.onload = function (evt) {
                        let base64 = evt.target.result;
                        that.updatePic(base64,0);
                    };
                    reader.readAsDataURL(file);
                }else{
                    this.$Notice.warning({
                        title: '文件格式不正确',
                        desc: '文件格式 ' + file.name + ' 不正确, 请选择 jpg 或 png'
                    });
                }


                return true;
            },
            editAvatarUpload(file) {
                console.log(file)
                if(file.type.indexOf('image')!=-1){
                    let reader = new FileReader();
                    var that=this
                    reader.onload = function (evt) {
                        let base64 = evt.target.result;
                        that.updatePic(base64,1);
                    };
                    reader.readAsDataURL(file);
                }else{
                    this.$Notice.warning({
                        title: '文件格式不正确',
                        desc: '文件格式 ' + file.name + ' 不正确, 请选择 jpg 或 png'
                    });
                }


                return true;
            },
            updatePic(base64,type){
                let that = this;
                that.$Message.loading({
                    content: '上传中...',
                    duration: 0
                });
                that.$func.ajax('upImg',{
                    token : that.$func.getUserInfo('token'),
                    img64 : base64,
                },function(r){
                    that.$Message.destroy()
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        console.log(r.type)
                        that.mapUrl="http://xhjg.oss-cn-beijing.aliyuncs.com"+r.type;
                        var name='',newVal = '';
                        if(type==1){name=that.mapName;}
                        that.$Modal.confirm({
                            title:'地图名称',
                            render: (h) => {
                                return h('Input', {
                                    props: {
                                        value: name,
                                        autofocus: true,
                                        placeholder: '请输入地图名称',
                                        maxlength:10
                                    },
                                    on: {
                                        input: (val) => {
                                            newVal = val
                                        }
                                    }
                                })
                            },
                            onOk: () => {
                                that.addAreaMap(type,newVal || name);
                            }
                        })

                    }
                },'','post',false)
            },
            getColumnDate() {
                var that=this;
                //将所有设备加入
                that.menuList=[];
                that.sensorList.map(function (item, index){
                    if(item.axisX){
                        item.axisX='';
                        item.axisY='';
                    }
                    that.menuList.push(item);
                });
                that.qitaDeviceList.map(function (item, index){
                    if(item.axisX){
                        item.axisX='';
                        item.axisY='';
                    }
                    that.menuList.push(item);
                });
                that.menuList.map(function (item, index){
                    that.deviceAxisList.map(function (item1, index1){
                        if(item.deviceId==item1.deviceId && that.mapId==item1.mapId){
                            //既可以新增属性,又可以触发视图更新
                            that.$set(that.menuList[index],"axisX", item1.axisX);
                            that.$set(that.menuList[index],"axisY", item1.axisY);
                            //更新坐标时用到id
                            that.$set(that.menuList[index],"mapDeviceId", item1.id);
                        }
                    })
                })
//                console.log("打印deviceAxisList*********");
//                console.log(that.deviceAxisList);
//                console.log("打印menuList*********");
//                console.log(that.menuList);
//                console.log("打印sensorList*********");
//                console.log(that.sensorList);
            },
            closeMenu() {
                this.visible = false;
            },
            showMenu() {
                var that=this;
                that.visible = false; // 先把模态框关死，目的是 第二次或者第n次右键鼠标的时候 它默认的是true
                that.visible = true; // 显示模态窗口，跳出自定义菜单栏
                event.preventDefault();
                that.axisX=event.clientX;
                that.axisY=event.clientY;
                console.log("打印xy*********");
                console.log(that.axisX);
                console.log(that.axisY);

            },
            savedata(item) {
//                alert("保存");
                console.log(item);
                console.log(item.deviceId);
                var that=this;
                that.$func.ajax('saveMapDevice', {
                    id:item.mapDeviceId,
                    mapId: that.mapId,
                    deviceId: item.deviceId,
                    axisX: that.axisX,
                    axisY: that.axisY
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.$Message.success(r.message);
                        that.getAreaMapDevice();
//                        setTimeout(function () {
//                            that.getColumnDate();
//                        },1000)
                    }
                })
            },
            deleteDevice(item1,index){
                var that = this;
                console.log('&&&&&&&&&&&&&&&&&&&&&&&&&&');
                that.$func.ajax('delAreaMapDevice', {
                    id:item1.mapDeviceId,
                    mapId: that.mapId,
                    deviceId: item1.deviceId,
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.$Message.success(r.message);
                        setTimeout(function () {
                            that.getAreaMapDevice();
                        },6000)

                    }
                })
            },
            sortIng(){
                this.sorting=false;
            },
            sortMap(){
                var that = this;
                that.$func.ajax('sortMap',{list: JSON.stringify(that.mapList)}, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.$Message.success(r.message);
                        that.sorting=true;
                        setTimeout(function () {
                            that.getAreaMap();
                        },6000)

                    }
                })
            },
            qhMap(item){
                var that=this;
                document.getElementById(item.mapId).style.backgroundColor='rgba(200, 200, 200, 1)';
                var list=document.getElementsByClassName("left-title");//获取class相同的所有span
                for(var i=0;i<list.length;i++) {
                    //获取当前遍历span的id ==>id2
                    var id2 = list[i].id;
                    //若选中id与遍历id不同，则将背景设置为另外一种颜色
                    if(item.mapId != id2){
                        document.getElementById(id2).style.backgroundColor="rgba(200, 200, 200, 0)";
                    }
                }
                //清空设备坐标
                that.menuList.map(function (item, index){
                    //既可以新增属性,又可以触发视图更新
                    that.$set(that.menuList[index],"axisX", '');
                    that.$set(that.menuList[index],"axisY", '');
                })
                that.mapId=item.mapId;
                document.getElementById("pic").src = item.imgUrl;
                that.mapUrl=item.imgUrl;
                that.mapId=item.mapId;
                that.mapName=item.mapName;
                that.areaNum=item.area;
                that.sort=item.sort;
                that.getAreaMapDevice();
            },
            closeMap(mapId){
                var that=this;
                that.$func.ajax('delMap', {
                    mapId:mapId,
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.$Message.success(r.message);
                        that.getAreaMap();
                    }
                })
            },
            //获取地图
            getAreaMap() {
                var that=this;
                that.$func.ajax('listAreaMap', {
                    areaId: that.$store.state.app.areaId,
                    type:1
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.$Message.success(r.message);
                        if(r.type.length>0){
                            that.mapList=r.type;
                            document.getElementById("pic").src = r.type[r.type.length-1].imgUrl;
                            that.mapUrl=r.type[r.type.length-1].imgUrl;
                            that.mapId=r.type[r.type.length-1].mapId;
                            that.mapName=r.type[r.type.length-1].mapName;
                            that.areaNum=r.type[r.type.length-1].area;
                            that.sort=r.type[r.type.length-1].sort;
                            setTimeout(function () {
                                document.getElementById(that.mapId).style.backgroundColor='rgba(200, 200, 200, 1)';
                                var list=document.getElementsByClassName("left-title");//获取class相同的所有span
                                for(var i=0;i<list.length;i++) {
                                    //获取当前遍历span的id ==>id2
                                    var id2 = list[i].id;
                                    //若选中id与遍历id不同，则将背景设置为另外一种颜色
                                    if(item.mapId != id2){
                                        document.getElementById(id2).style.backgroundColor="rgba(200, 200, 200, 0)";
                                    }
                                }
                            },500)
                            that.getAreaMapDevice();
                        }else{
                            //清空
                            that.mapList=[];
                            document.getElementById("pic").src = '';
                        }
                    }
                })
            },
            //获取地图下的设备
            getAreaMapDevice() {
                var that=this;
                that.$func.ajax('listAreaMapDevice', {
                    mapId: that.mapId,
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.deviceAxisList=r.type;
                        setTimeout(function () {
                            that.getColumnDate();
                        },5000)

                    }
                })
            },
            //添加地图
            addAreaMap(type,name) {
                var that=this;
                var parameters={};
                if(type==0){
                    parameters={
                        areaId:that.$store.state.app.areaId,
                        imgUrl: that.mapUrl,
                        area:that.areaNum,
                        type:1,
                        mapName:name,
                        sort:that.sort+1
                    };
                }else{
                    parameters={
                        areaId:that.$store.state.app.areaId,
                        imgUrl: that.mapUrl,
                        area:that.areaNum,
                        type:1,
                        mapName:name,
                        mapId:that.mapId,
                        sort:that.sort
                    };
                }
                that.$func.ajax('addAreaMap', parameters, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message);
                    } else {
                        that.$Message.success(r.message);
                        document.getElementById("pic").src = that.mapUrl;
                        that.dapingRefresh();

                    }
                })
            },

            //添加数据
            listCatList(){
                const that = this;
                that.$func.ajax('catList', {
                    catPosition: 3,
                    flag: 1,
                    token: that.$func.getToken(),
                    areaId: that.$store.state.app.areaId
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message, 'error');
                    } else {
                        that.list=[];
                        that.sensorList=[];
                        that.qitaDeviceList=[];
                        that.list = r.type;
                        console.log('&&&&&&&&&&&&&&&&&&&&&&&&&&');
                        console.log(that.list);
                        that.list.map(function (item, index) {
                            item.devices.map(function (item2, index2) {
                                item2.status=true;
                                item2.isOpen=0;
                                if (that.isSensor(item2)) {
                                    that.sensorList.push(item2);
                                }else{
                                    that.qitaDeviceList.push(item2)
                                }
                            })
                        })
//                        if(that.sensorList.length>0){
                            console.log("传感器列表")
                            console.log(that.sensorList)
                            that.getSensorData();
//                        }
                        that.getDevideNotice();
                        setInterval(function () {
                            that.getSensorData();
                            that.getDevideNotice();
                            setTimeout(function () {
                                that.getColumnDate();
                            },5000)
                        }, 10*6000)

                    }
                })
            },

            dapingRefresh() {
                const that = this;
                console.log(that.$store.state.app)
                this.areaId = that.$store.state.app.areaId;
                this.areaName = that.$store.state.app.areaName;

                that.onClose();
                that.listCatList();
                that.getAreaMap();
                that.getListStandard();
                //第二次调用，防止为加载完设备就对比
                setTimeout(function () {
                    that.getColumnDate();
                },6000)
            },
            //获取设备预警状态
            getDevideNotice(){
                const that = this;
                that.qitaDeviceList.map(function (device,index) {
                    //设备默认不正常
                    device.status = false;
                    //设备默认关闭
                    device.switchStatus = false;
                    that.$func.ajax('refreshInfo', {
                        token: that.$func.getToken(),
                        deviceNo: device.deviceId
                    }, function (r) {
                        if (r.statusCode) {//有记录
                            device.info=r.type.info;
                            device.status = true;
                            device.switchStatus = r.type.info.isOpen==0? false:true;
                            device.img=r.type.info.isOpen==0?  r.type.info.infoList[0].def5 : r.type.info.infoList[0].def6;
                        } else {//离线
                            device.status = false;
                            device.switchStatus = false;
                            that.getImg(device);
                        }
                    }, function () {
                        device.status = false;
                        device.switchStatus = false;
                        that.getImg(device);
                    })
                })
            },
            isSensor(item) {
                return item.eid == '3' || item.eid == '4' || item.eid == '5' || item.eid == '15' || item.eid == '24' ||
                    item.eid.indexOf('sensor') != -1
            },
            //关闭侧滑
            onClose(){
                this.type = 0
                this.show = false;
            },
            selectArea(){
                const that = this;
                that.type = 1;
                that.winTitle = "选择区域";
                that.show = true;
            },
            // 固定是音乐弹出
            see(item){
                const that = this;
                this.sbInfo = item
                that.winTitle = item.deviceName;
                if (item.eid.indexOf('music') != -1) {
                    that.type = 3;
                    that.sbInfo.modeType = 2;
                } else {
                    that.type = 2;
                }
                that.show = true;
            },

            listArea(){
                var that = this;
                that.$func.ajax('listArea', {
                    token: that.$func.getToken(),
                }, function (r) {
                    if (!r.statusCode) {
                        that.$func.msg(r.message, 'error');
                    } else {
                        if (r.type.length > 0) {
                            that.areaList = r.type;
                            //全局记录areaId
                            let setAreaId;
                            setAreaId = {
                                areaId: that.areaList[0].areaId,
                                areaName: that.areaList[0].areaName
                            };
                            that.$store.commit('setAreaId', setAreaId);
                            that.dapingRefresh();
                        }


                    }
                })
            },

            //获取传感器数值
            getSensorData(){
                const that = this;
                that.sensorList.map(function (item, index) {
                    that.$func.ajax('refreshInfo', {
                        token: that.$func.getToken(),
                        deviceNo: item.deviceId
                    }, function (r) {
                        if (r.statusCode) {//有记录
                            var info=r.type.info;
                            console.log("==================获取传感器数值================")
                            console.log(info)
                            item.value=info.value;//显示当前值要用到
                            item.info=info;
                            item.img=r.type.info.infoList[0].level==1?  r.type.info.infoList[0].def4 : r.type.info.infoList[0].level==2?  r.type.info.infoList[0].def5 : r.type.info.infoList[0].def6;

                        }else{
                            that.getImg(item);
                        }
                    }, function () {
                        that.getImg(item);
                    });
                })


            },
            //获取离线图标（默认中）
            getImg(device){
                const that = this;
                that.listStandard.map(function (item,index) {
                    if (that.isSensor(device)) {
                        if(device.eid==item.eid){
                            device.img= item.vdef5;
                        }
                    }else{//其他设备
                        if(device.deviceName.indexOf('雾森') != -1){
                            if(item.valueType.indexOf('switch-ws') != -1){
                                device.img= item.vdef5;
                            }
                        }else{
                            if(item.eid==item.valueType){
                                device.img= item.vdef5;
                            }
                        }
                    }


                })
            },
            //获取数据评价标准
            getListStandard(){
                const that = this;
                that.$func.ajax('listSensorStandard',{
                    token: that.$func.getToken(),
                },function (r) {
                    if(!r.statusCode){
                        that.$func.msg(r.message,'error');
                    }else{
                        that.listStandard=[];
                       that.listStandard= r.type;
                    }
                })
            },

        }
    };
</script>
